import { keepPreviousData } from '@tanstack/react-query';
import { Flex } from 'antd';
import { FC } from 'react';

import {
  DataObjectGroupType,
  EmptyData,
  keepStaleInMinutes,
  Main,
  Padding,
  useDataObjectGroupsWithDescriptionsQuery,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { SampleHeader } from './SampleHeader';
import { Helmet } from 'react-helmet-async';

import translations from './Samples.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('samples-directory');
addTranslations(translations);

export const SampleDirectory: FC = () => {
  const { t } = useTranslation();

  const { data: dataObjectGroupsWithDescriptions, isLoading } =
    useDataObjectGroupsWithDescriptionsQuery(
      { groupType: DataObjectGroupType.I },
      {
        placeholderData: keepPreviousData,
        ...keepStaleInMinutes(1),
      }
    );

  return (
    <>
      <Helmet>
        <title>{t('title')}</title>
      </Helmet>
      <Main>
        <Main.Col border={false}>
          <Main.Content padding={false}>
            <Padding>
              <Flex vertical gap="large">
                <SampleHeader
                  data={dataObjectGroupsWithDescriptions}
                  isLoading={isLoading}
                  view="samples"
                />
                <EmptyData>{t('emptyData')}</EmptyData>
              </Flex>
            </Padding>
          </Main.Content>
        </Main.Col>
      </Main>
    </>
  );
};
